































































































import { Component } from "vue-property-decorator";
import { EventWidgetComponent } from "../EventWidget";
import MagicValidator from "../../../magic/MagicValidator.vue";

import object from "./object";

@Component({
  name: "SelectWidget",
  components: {
    selectComponent: () =>
      import("../../../components/SelectComponent/index.vue"),
    MagicValidator
  }
})
export default class SelectWidget
  extends EventWidgetComponent
  implements
    App.PuttedWidgetComponent,
    App.LinkedWidgetComponent,
    App.PutAbleWidgetComponent
{
  private show: boolean = false;
  private list: any[] = [];

  putModel: any = {};
  params: App.LinkedWidgetComponentParam[] = [];

  initText() {
    if (this.value) {
      const ext = Array.isArray(this.widget.ext)
        ? this.widget.ext
        : [this.widget.ext];
      this.widget.text = ext.map((i: any) => i.fieldName).join(",");
    }
  }

  reset() {
    this.widget.text = "";
    this.value = "";

    this.putModel = { selectId: this.value, selectName: this.widget.text };
    this.handleEvent(this.value);
  }

  showSelectorMainForm() {
    object.showSelectObject({
      fieldType: this.widget.property.propertyType,
      limiter: this.widget.property.configValue,
      selected: this.value
    });
  }

  refresh(option: App.LinkEventOption) {
    this.params = [
      {
        key: option.property,
        value: option.value
      }
    ];

    this.reset();
  }

  setValue(value: string) {
    // this.reset();

    if (!/[0-9]+/.test(value)) {
      this.value = "";
      this.widget.text = "";
    } else {
      this.value = value.split(",")[0];
      this.widget.text = value.split(",")[1];
    }

    this.putModel = { selectId: this.value, selectName: this.widget.text };
    this.handleEvent(this.value);
  }

  confirm(data: any) {
    // if (!data.source.length) return false;
    this.widget.ext = data.source;
    const item = data.source[0];
    this.putModel = item;
    this.handleEvent(this.value);
  }

  created() {
    this.initText();
  }

  async showHandler() {
    if (!this.widget.readonly) {
      this.show = true;
    }
  }
}
